import createReactComponent from '../createReactComponent';
export default createReactComponent('text-align-center', 'TextAlignCenter', [["path",{"d":"M4.5 6h15M7 10h10M4.5 14h15M7 18h10","key":"svg-0"}]]);